// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__X185n","right":"styles_right__31PS6"};